import { useEffect, useState } from 'react';
import { PageHeader, StatCard, LoadingSpinner } from '../components/common/PageHeader';
import { listProducts } from '../services/productService';
import { listCategories } from '../services/categoryService';
import { listCombos } from '../services/comboService';
import { listConsultants } from '../services/consultantService';
import { listOrders } from '../services/orderService';
import { listUsers } from '../services/userService';
import { formatCurrency } from '../utils/format';
import { getErrorMessage } from '../services/apiClient';
import { useToast } from '../context/ToastContext';

export default function DashboardPage() {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    products: 0,
    categories: 0,
    combos: 0,
    consultants: 0,
    orders: 0,
    users: 0,
    revenue: 0,
    pendingOrders: 0,
  });

  useEffect(() => {
    async function load() {
      try {
        const [productsRes, categoriesRes, combosRes, consultantsRes, ordersRes, usersRes] =
          await Promise.all([
            listProducts({ limit: 1 }),
            listCategories(),
            listCombos({ limit: 1 }),
            listConsultants(),
            listOrders({ limit: 100 }),
            listUsers({ limit: 1 }),
          ]);

        const orders = ordersRes.data || [];
        const revenue = orders
          .filter((o) => o.status !== 'cancelled')
          .reduce((sum, o) => sum + (o.total || 0), 0);
        const pendingOrders = orders.filter((o) => o.status === 'pending').length;

        setStats({
          products: productsRes.meta?.total ?? productsRes.data?.length ?? 0,
          categories: categoriesRes.data?.length ?? 0,
          combos: combosRes.meta?.total ?? combosRes.data?.length ?? 0,
          consultants: consultantsRes.data?.length ?? 0,
          orders: ordersRes.meta?.total ?? orders.length,
          users: usersRes.meta?.total ?? usersRes.data?.length ?? 0,
          revenue,
          pendingOrders,
        });
      } catch (err) {
        showToast(getErrorMessage(err), 'error');
      } finally {
        setLoading(false);
      }
    }
    load();
  }, [showToast]);

  if (loading) return <LoadingSpinner text="Loading dashboard..." />;

  return (
    <div>
      <PageHeader
        title="Dashboard"
        description="Overview of your RealAyurveda store"
      />
      <div className="stats-grid">
        <StatCard title="Total Products" value={stats.products} icon="" />
        <StatCard title="Categories" value={stats.categories} icon="" />
        <StatCard title="Combo Offers" value={stats.combos} icon="" />
        <StatCard title="Consultants" value={stats.consultants} icon="" />
        <StatCard title="Total Orders" value={stats.orders} icon="" />
        <StatCard title="Total Users" value={stats.users} icon="" />
        <StatCard
          title="Revenue"
          value={formatCurrency(stats.revenue)}
          description="From non-cancelled orders"
          icon=""
        />
        <StatCard
          title="Pending Orders"
          value={stats.pendingOrders}
          description="Awaiting confirmation"
          icon=""
        />
      </div>
    </div>
  );
}
